import angular from "angular";

let PopUpListController = function (
  PopUp,
  NotificationService,
  $mdDialog,
  $filter,
  $scope,
  $state,
  State,
  City,
  Toast
) {
  let $ctrl = this;
  angular.extend($ctrl, {
    onChangeRegionType,
    onChangeState,
    filterContent,
    setListContent,
  });

  $ctrl.states = [];
  $ctrl.cities = [];
  $ctrl.filter = {};
  $ctrl.allSelected = false;
  $ctrl.original = {
    states: [],
    cities: [],
  };
  $ctrl.regionTypes = [
    { text: "Todas", value: null },
    { text: "Com vacinas", value: true },
    { text: "Não possuem vacinas", value: false },
  ];

  function filterContent(query, type) {
    let filtered = [];

    if (query) {
      filtered = $ctrl.original[type].filter(({ name }) => {
        name = name.toLowerCase();
        return (
          name.includes(query) ||
          name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(query)
        );
      });
    }

    $ctrl[type] = query ? filtered : $ctrl.original[type];
  }

  function onChangeRegionType() {
    $ctrl.filter.state_id = [];
    $ctrl.selectedStates = [];
    $ctrl.selectedCities = [];
    $ctrl.filter.city_id = [];
    $ctrl.disabledFilterStateCities =
      $ctrl.campaignPopUp.only_vaccine_regions !== null;
  }

  function loadDomainResources() {
    $ctrl.uiState = "LOADING";

    let promises = [];
    promises.push(State.index({ limit: 10000000000 }));

    return Promise.all(promises);
  }

  activate();

  function loadResource() {
    $ctrl.id = $state.params.id;

    loadDomainResources()
      .then((result) => {
        $ctrl.states = result[0];
        if ($ctrl.id) {
          $ctrl.uiState = "LOADING";
          PopUp.show($ctrl.id)
            .then((response) => {
              $ctrl.campaignPopUp = angular.copy(response);
              if (response.state_id) {
                onChangeState(response.state_id);
              }
              $ctrl.filter = {
                state_id: response.state_id === null ? null : response.state_id,
                city_id: response.city_id === null ? null : response.city_id,
              };
              if (response.city_id.length) {
                $ctrl.filter.city_id = response.city_id.map((id) =>
                  id.toString()
                );
              }

              if (response.state_id.length)
                $ctrl.campaignPopUp.only_vaccine_regions = null;
              $ctrl.uiState = "COMPLETE";
            })
            .catch((err) => {
              $ctrl.uiState = "ERROR";
            });
        } else {
          $ctrl.campaignPopUp = {
            title: "",
            status: true,
            image_url: "",
            url_campaign: "",
            only_vaccine_regions: null,
          };
        }
      })
      .catch((err) => {
        console.log("err:", err);
        $ctrl.uiState = "ERROR";
      });
  }

  function onChangeState(stateIdArr, clearCities = false) {
    if (stateIdArr.length !== 0) {
      const lastPosition = stateIdArr.length - 1;
      if (
        stateIdArr.includes(null) &&
        stateIdArr[lastPosition] === null &&
        lastPosition !== 0
      ) {
        $ctrl.filter.state_id = [null];
        $ctrl.filter.city_id = [null];
        return;
      } else if (stateIdArr[0] === null && stateIdArr.length > 1) {
        stateIdArr.split(0, 1);
      }
      $ctrl.loadingCities = true;
      City.index({
        state_id: stateIdArr,
        limit: 1000000,
      })
        .then((cities) => {
          $ctrl.cities = cities;
          $ctrl.original.cities = cities;
          $ctrl.selectedCities = [];
          $ctrl.loadingCities = false;
        })
        .catch((err) => {
          console.log("err:", err);
          $ctrl.loadingCities = false;
        })
        .finally(() => {
          angular
            .element(document.querySelector(".input-search-city"))
            .on("keydown", function (ev) {
              ev.stopPropagation();
            });
        });
    }

    if (clearCities) {
      $ctrl.search = "";
      $ctrl.filter.city_id = null;
      $ctrl.cities = [];
    }
  }

  function setListContent(name, list) {
    if (name) {
      const idx = list.findIndex((city) => {
        return name === city;
      });

      if (idx >= 0) {
        list.splice(idx, 1);
      } else {
        list.push(name);
      }
    } else {
      list.length = 0;
    }
  }

  function activate() {
    loadResource();
    $ctrl.promise;
  }

  $ctrl.saveData = function () {
    const data = angular.extend($ctrl.campaignPopUp, $ctrl.filter);
    if (data.only_vaccine_regions === null) delete data.only_vaccine_regions;
    if (data.state_id && data.state_id.length && data.state_id.includes(null)) {
      data.state_id = null;
    }

    if (data.city_id && data.city_id.length) {
      if (data.city_id.includes(null)) data.city_id = null;
      else {
        const listId = data.city_id.map((id) => {
          return Number(id);
        });
        data.city_id = listId;
      }
    }
    $ctrl.promise = PopUp.save(data)
      .then((response) => {
        $state.go("pop-up.list");
      })
      .catch((err) => {
        if (err.status === 400) {
          const complement = "";
          Toast.error(`Já existe um banner ativo para ${complement}`);
        }
      });
  };

  $ctrl.deletePopUp = function () {
    let confirm = $mdDialog
      .confirm()
      .textContent(`Remover pop-up "${$ctrl.campaignPopUp.title}"`)
      .ariaLabel(`Remover pop-up "${$ctrl.campaignPopUp.title}"`)
      .targetEvent(event)
      .ok($filter("translate")("common-yes"))
      .cancel($filter("translate")("common-cancel"));

    $mdDialog
      .show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        PopUp.destroy($ctrl.campaignPopUp)
          .then((response) => {
            Toast.success($filter("translate")("common-detail-delete-success"));
            $state.go("pop-up.list");
          })
          .catch((err) => {
            Toast.error($filter("translate")("common-server-error"));
          });
      })
      .catch(() => {});
  };

  $ctrl.getStateNames = function(){
    const map = $ctrl.filter.state_id.map(_id => {
      const idx = $ctrl.states.findIndex(({id}) => _id.toString() === id.toString())
      if(idx > -1) return $ctrl.states[idx].name
      else return ""
    })
    return map.join(", ")
  }

  
  $ctrl.getCitiesNames = function(){
    const map = $ctrl.filter.city_id.map(_id => {
      const idx = $ctrl.cities.findIndex(({id}) => _id.toString() === id.toString())
      if(idx > -1) return $ctrl.cities[idx].name
      else return ""
    })
    return map.join(", ")
  }


  $ctrl.toggle = function (id) {
    var idx = $ctrl.campaignPopUp.regions.indexOf(id);
    if (idx > -1) {
      $ctrl.campaignPopUp.regions.splice(idx, 1);
    } else {
      $ctrl.campaignPopUp.regions.push(id);
    }
  };

  $ctrl.exists = function (id) {
    return $ctrl.campaignPopUp.regions.indexOf(id) > -1;
  };

  $ctrl.allRegions = function () {
    $ctrl.allSelected = !$ctrl.allSelected;
    $ctrl.campaignPopUp.regions = [];
  };
};
PopUpListController.$inject = [
  "PopUp",
  "NotificationService",
  "$mdDialog",
  "$filter",
  "$scope",
  "$state",
  "State",
  "City",
  "Toast",
];

export default PopUpListController;



// WEBPACK FOOTER //
// ./client/app/components/pop-up/pop-up-detail.controller.js